import React from 'react';
import { useTranslation } from 'react-i18next';
import { navigationLinks } from '../../data/mockData';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="bg-bg-tertiary text-white pt-20 pb-10 mt-auto rounded-t-block overflow-hidden relative">
            {/* Decorative large "Z" background hint */}
            <div className="absolute -right-20 -bottom-20 text-[300px] font-heading font-bold text-white/5 pointer-events-none leading-none select-none">
                Z
            </div>

            <div className="container mx-auto px-6 md:px-12 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 lg:gap-8 mb-16">

                    {/* Brand Column */}
                    <div className="col-span-1 md:col-span-1 border-r border-white/10 pr-8">
                        <a href="/" className="flex flex-col gap-1 mb-6">
                            <img
                                src="/lazmetalslogo.png"
                                alt="Laz Metals Logo"
                                className="h-20 w-auto object-contain self-start opacity-90 hover:opacity-100 transition-opacity"
                            />
                        </a>
                        <p className="text-gray-300 text-sm leading-relaxed mb-6">
                            {t('footer.desc')}
                        </p>
                    </div>

                    {/* Navigation */}
                    <div>
                        <h4 className="font-body font-bold text-sm tracking-wider uppercase mb-6 text-primary-light">{t('footer.nav')}</h4>
                        <ul className="flex flex-col gap-3">
                            {navigationLinks.map((link) => (
                                <li key={link.label}>
                                    <a href={link.href} className="text-gray-300 hover:text-white transition-colors text-sm">
                                        {t(link.label)}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Services Quick Links */}
                    <div>
                        <h4 className="font-body font-bold text-sm tracking-wider uppercase mb-6 text-primary-light">{t('footer.capabilities')}</h4>
                        <ul className="flex flex-col gap-3">
                            <li><a href="/servicios#compra" className="text-gray-300 hover:text-white transition-colors text-sm">{t('footer.cap1')}</a></li>
                            <li><a href="/servicios#suministro" className="text-gray-300 hover:text-white transition-colors text-sm">{t('footer.cap2')}</a></li>
                            <li><a href="/servicios#transporte" className="text-gray-300 hover:text-white transition-colors text-sm">{t('footer.cap3')}</a></li>
                            <li><a href="/servicios#limpieza" className="text-gray-300 hover:text-white transition-colors text-sm">{t('footer.cap4')}</a></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="font-body font-bold text-sm tracking-wider uppercase mb-6 text-primary-light">{t('footer.contact')}</h4>
                        <ul className="flex flex-col gap-4 text-sm text-gray-300">
                            <li className="flex items-start gap-3">
                                <MapPin size={18} className="text-primary mt-0.5 shrink-0" />
                                <span>3625 NW 82nd Ave, Suite 318<br />Doral, FL 33166</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone size={18} className="text-primary shrink-0" />
                                <span>+1 929 290 2022</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail size={18} className="text-primary shrink-0" />
                                <span>Luislazo@lazmetals.com</span>
                            </li>
                        </ul>
                    </div>

                </div>

                {/* Bottom Bar */}
                <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-gray-400 text-xs text-center md:text-left">
                        &copy; {new Date().getFullYear()} {t('footer.rights')}
                    </p>
                    <div className="flex items-center gap-6">
                        <a href="/terms" className="text-gray-400 hover:text-white text-xs transition-colors">{t('footer.terms')}</a>
                        <a href="/privacy" className="text-gray-400 hover:text-white text-xs transition-colors">{t('footer.privacy')}</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
